import { createFileRoute } from '@tanstack/react-router';

import { SmsTemplatesPage } from '../modules/org-sms-templates/ui/pages/SmsTemplatesPage';

export const Route = createFileRoute('/_authenticated/dashboard/settings/sms-templates/')({
  component: SmsTemplatesPage,
  staticData: {
    breadcrumb: ['Manage', 'Settings', 'SMS Templates'],
  },
});
